import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeCheckboxBaseComponent } from './e5core-ui-work-field-type-checkbox-base';

@Component({
  selector: 'e5core-ui-work-field-type-checkbox-material',
  templateUrl: './e5core-ui-work-field-type-checkbox-material.component.html',
  styleUrls: ['./e5core-ui-work-field-type-checkbox-material.component.css']
})
export class E5coreUiWorkFieldTypeCheckboxMaterialComponent extends E5coreUiWorkFieldTypeCheckboxBaseComponent {
}

